module.exports = __webpack_public_path__ + "media/images/icon__predict@2x-7a180e4005cdc42641a126e5d28c5d7e.png";